module.exports = __webpack_public_path__ + "img/appAsset-brand--sri.b8ef9dd1.svg";